// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SlackIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="#E01E5A"
      d="M5.62 14.9a2.31 2.31 0 0 1-4.62 0 2.3 2.3 0 0 1 2.31-2.31h2.3zM6.78 14.9a2.31 2.31 0 0 1 4.62 0v5.78a2.31 2.31 0 0 1-4.62 0z"
    />
    <path
      fill="#36C5F0"
      d="M9.1 5.62A2.31 2.31 0 0 1 9.1 1a2.3 2.3 0 0 1 2.31 2.31v2.3zM9.1 6.78a2.31 2.31 0 0 1 0 4.63H3.31a2.31 2.31 0 0 1 0-4.62z"
    />
    <path
      fill="#2EB67D"
      d="M18.38 9.1a2.31 2.31 0 0 1 4.62 0 2.3 2.3 0 0 1-2.3 2.31h-2.32zM17.22 9.1a2.31 2.31 0 0 1-4.62 0V3.31a2.31 2.31 0 0 1 4.62 0z"
    />
    <path
      fill="#ECB22E"
      d="M14.9 18.38a2.31 2.31 0 0 1 0 4.62 2.3 2.3 0 0 1-2.31-2.31v-2.3zM14.9 17.22a2.31 2.31 0 0 1 0-4.62h5.78a2.31 2.31 0 0 1 0 4.62z"
    />
  </svg>,
  "Slack",
);
export default SlackIcon;
